import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useRecipeHistoryService(config) {
	const user = useUserContext(config);
	const [service, setService] = useState(() => {
		return createRecipeHistoryService(user, config);
	});

	useEffect(() => {
		setService(createRecipeHistoryService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return service;
}

function createRecipeHistoryService(user, config) {
	const api = createAxiosApi("", user, config);

	function getRecipeHistory(recipeId, includeCurrent, successCallback, errorCallback) {
		const includeCurrentParam = includeCurrent ? "?includeCurrent=true" : "";
		api.get(`RecipeHistory/recipe/${recipeId}${includeCurrentParam}`)
			.then(response => {
				if (successCallback) successCallback(response);
			})
			.catch(error => {
				if (errorCallback) errorCallback(error);
			});
	}

	function getHistoryEntry(recipeHistoryId, successCallback, errorCallback) {
		api.get(`RecipeHistory/${recipeHistoryId}`)
			.then(response => {
				if (successCallback) successCallback(response);
			})
			.catch(error => {
				if (errorCallback) errorCallback(error);
			});
	}

	function restoreHistoryEntry(recipeHistoryId, successCallback, errorCallback) {
		api.post(`RecipeHistory/${recipeHistoryId}/restore`)
			.then(response => {
				if (successCallback) successCallback(response);
			})
			.catch(error => {
				if (errorCallback) errorCallback(error);
			});
	}

	return {
		getRecipeHistory,
		getHistoryEntry,
		restoreHistoryEntry
	};
}
